import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface DeviceAuthRequestInfo {
  userCode: string;
  status: 'pending' | 'approved' | 'denied';
  clientLabel?: string;
  requestedFrom?: string;
  expiresAt: string;
  alreadyApproved: boolean;
}

/**
 * The browser half of the CLI device-authorization exchange. The command-line
 * tool never talks to this app — it polls the API — so all this needs to do is
 * describe a pending request and record the operator's answer.
 */
@Injectable()
export class DeviceAuthService {
  constructor(private http: HttpClient) {}

  serviceUrl = '/api/auth/device';

  describe(userCode: string): Observable<DeviceAuthRequestInfo> {
    return this.http.get<DeviceAuthRequestInfo>(
      `${this.serviceUrl}/${encodeURIComponent(userCode)}`
    );
  }

  approve(userCode: string): Observable<{ status: string }> {
    return this.http.post<{ status: string }>(
      `${this.serviceUrl}/${encodeURIComponent(userCode)}/approve`,
      {}
    );
  }

  deny(userCode: string): Observable<{ status: string }> {
    return this.http.post<{ status: string }>(
      `${this.serviceUrl}/${encodeURIComponent(userCode)}/deny`,
      {}
    );
  }
}
